import {Component, OnInit} from '@angular/core';
import {InventoryControllerService, ProductDocumentDto, ProductDto, ProductHighlightDto, ProductOverviewDto, ProductSpecificationDto} from '../../../@api';
import {v4 as uuidv4} from 'uuid';

@Component({
    selector: 'app-new-product',
    templateUrl: './new-product.component.html',
    styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent implements OnInit {
    product: ProductDto = {};

    constructor(private inventoryControllerService: InventoryControllerService) {
    }

    async ngOnInit(): Promise<void> {
        this.product = await this.inventoryControllerService.findProductByCode('MC4Y-4WAY').toPromise();
        console.log(JSON.stringify(this.product));
        //this.product = JSON.parse('{"id":1,"uid":"a022209a-126c-11ee-be56-0242ac120002","code":"SAMPLE-ES","sku":"SAMPLE","name":"Sample Off-grid Inverter","longName":"Sample 5kW Output Solar Off-grid Inverter (SAMPLE-ES)","brand":"Growatt","image":"https://www.solarcentral.co.za/images/SAMPLE-ES.png","price":9999.95,"category":"Inverters","inventory":0,"inventoryStatus":"INSTOCK","qty":null,"rating":4.3,"reviews":1,"title":"Solar Central | Products | Sample","keywords":"Sample keywords","description":"Sample description","root":"root","highlights":[],"overviews":[],"specifications":[],"documents":[],"distributors":[],"new":false}');

        this.product.id = 0;
        this.product.uid = uuidv4();
        this.product.highlights = [].concat(this.product.highlights);
        this.product.highlights.forEach((p: ProductHighlightDto): number => p.id = 0);
        this.product.overviews = [].concat(this.product.overviews);
        this.product.overviews.forEach((p: ProductOverviewDto): number => p.id = 0);
        this.product.specifications = [].concat(this.product.specifications);
        this.product.specifications.forEach((p: ProductSpecificationDto): number => p.id = 0);
        this.product.documents = [].concat(this.product.documents);
        this.product.documents.forEach((p: ProductDocumentDto): number => p.id = 0);
    }
}
